import { useQuery } from '@tanstack/react-query';
import { getUserSettings } from 'Services/user';
import { trackError } from 'Utils/errorMonitoring';

export default function useUserSettings() {
    const { data = {}, isLoading } = useQuery({
        queryKey: ['settings-storage'],
        queryFn: getUserSettings,
        onError: (error) => {
            trackError(error);
        },
    });

    return { settings: data, isLoading };
}
